import React          from 'react';
import * as PropTypes from 'prop-types';

import RangeSlider from './base/RangeSlider';

const RenderMagnetRangeSlider = props => {
  let {
        data,
        disabled,
        value,
        step,
        onChange,
      }          = props;
  data           = data.map(item => +item);
  const minValue = data[0];
  const maxValue = data[data.length - 1];

  return (
    <RangeSlider
      magnet={true}
      data={data}
      disabled={disabled || data.length <= 2}
      value={value}
      minValue={minValue}
      maxValue={maxValue}
      step={step}
      onChange={onChange}
      ruler={true}
      fromTo={false}
      currency={false}
    />
  );
};

RenderMagnetRangeSlider.defaultProps = {
  disable: false,
  step:    1,
};

RenderMagnetRangeSlider.propTypes = {
  data:     PropTypes.array.isRequired,
  disable:  PropTypes.bool,
  value:    PropTypes.object.isRequired,
  step:     PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default RenderMagnetRangeSlider;